export default __webpack_public_path__ + "static/media/stars.88766813.svg";